import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatChip } from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-task-status-indicator',
  templateUrl: './task-status-indicator.component.html',
  imports: [MatChip, MatIcon, TranslateModule, NgIf],
})
export class TaskStatusIndicatorComponent {
  @Input() public status!: string;
  @Input() public showIcon = false;
}
